var _defs, _rect, _rect2, _rect3, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 196.93,
    height: 194.273,
    viewBox: "0 0 196.93 194.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 123.559,
    height: 158.465,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M216.624,216.062a28.882,28.882,0,0,1,2.391-7.873c1.593-3.282,4.357-5.778,8.088-6.07,3.176-.249,6.358-.379,9.541-.491a56.167,56.167,0,0,1,8.857-.066,16.968,16.968,0,0,1,8.407,3.389c2.5,1.979,2.923,4.886,3.134,7.906,1.236,14.828,2.141,29.664,3.829,44.454.667,5.846,4.219,38.025,4.257,42.349-8.436,3.609-17.895,3.838-27.067,3.6-7.936-.209-16.012-.758-23.417-3.618-.005-13.881.753-27.725.749-41.6,0-7.174-.042-14.348.065-21.521C215.559,229.715,215.547,222.8,216.624,216.062Z",
    transform: "translate(-214.643 -201.394)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038",
    transform: "translate(-8.436 -36.123)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(35.88 36.123)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 102.673,
    height: 194.273,
    rx: 15,
    transform: "translate(21.893)",
    fill: "#282d3a"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 102.673,
    height: 194.273,
    rx: 15,
    transform: "translate(17.867)",
    fill: "#343a4a"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 90.272,
    height: 158.465,
    rx: 15,
    transform: "translate(24.067 11.732)",
    fill: "#43afe9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M254.47,102.347H228.64A1.345,1.345,0,0,1,227.295,101h0a1.345,1.345,0,0,1,1.345-1.345h25.83A1.345,1.345,0,0,1,255.815,101h0A1.345,1.345,0,0,1,254.47,102.347Z",
    transform: "translate(-172.352 -95.571)",
    fill: "#343a4a",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(0 11.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(7.152 6.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M227.9,446.444a25.921,25.921,0,0,0-4.3,2.121c-1.208.86-2.812,2.944-2.066,4.556.689,1.488,2.816,1.264,4.27,1.421a31.5,31.5,0,0,0,14.6-1.8c.024-3.172.062-5.153-1.231-8.225-.356-.847-.581-3.576-1.546-3.873a1.3,1.3,0,0,0-.577,0c-3.672.563-4.023,2.006-6.636,4.275A10.372,10.372,0,0,1,227.9,446.444Z",
    transform: "translate(-177.089 -252.534)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M263.282,446.444a25.92,25.92,0,0,0-4.3,2.121c-1.208.86-2.812,2.944-2.066,4.556.689,1.488,2.816,1.264,4.27,1.421a31.5,31.5,0,0,0,14.6-1.8c.024-3.172.062-5.153-1.231-8.225-.356-.847-.581-3.576-1.546-3.873a1.3,1.3,0,0,0-.577,0c-3.673.563-4.023,2.006-6.636,4.275A10.372,10.372,0,0,1,263.282,446.444Z",
    transform: "translate(-191.449 -252.534)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M153.348,225.087a21.082,21.082,0,0,0,2.034,1.115,20.67,20.67,0,0,1,2.088,1.05,31.268,31.268,0,0,1,2.737,2.224.454.454,0,0,0,.26.126.445.445,0,0,0,.262-.113,5.736,5.736,0,0,0,1.845-2.329.863.863,0,0,0,.1-.409,1.012,1.012,0,0,0-.206-.449c-1.018-1.551-1.223-3.658-1.823-5.4a17.738,17.738,0,0,1-.885-4.1,3.568,3.568,0,0,0-.651-2.176.634.634,0,0,0-.554-.245.668.668,0,0,0-.252.127c-1.048.764-1.128,2.741-1.175,3.943a31.246,31.246,0,0,0-3.68-5.666c-.49-.647-1.18-1.371-1.968-1.175a2.571,2.571,0,0,0,.325,2.211l1.652,3.408a16.712,16.712,0,0,0-3.391-4.607,1.09,1.09,0,0,0-.882-.414.761.761,0,0,0-.531.813,2.218,2.218,0,0,0,.392.976l2.3,3.82a13.692,13.692,0,0,0-2.585-2.68,1.022,1.022,0,0,0-.961-.3.707.707,0,0,0-.358.762,1.978,1.978,0,0,0,.393.808,29.891,29.891,0,0,0,2.544,3.154,4.127,4.127,0,0,0-2.444-1.816,1.048,1.048,0,0,0-.657-.01.813.813,0,0,0-.392.946,6.772,6.772,0,0,0,1.476,2.125,21.451,21.451,0,0,0,4.986,4.281Z",
    transform: "translate(-146.86 -159.583)",
    fill: "#fac39a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M193.616,214.372c-.164.487-.32.976-.471,1.463A38.453,38.453,0,0,1,189.881,224a9.936,9.936,0,0,1-4.325,4.3,7.522,7.522,0,0,1-6.606-.551,19.019,19.019,0,0,1-5.646-5.41c-3.041-4.222-6.987-.343-9.464,2.651a4.711,4.711,0,0,0-1.152,2.134c-.5,2.993,3.265,6.742,5.128,8.766,4.557,4.955,11.628,9.456,18.633,8.727,7.67-.8,12.779-9.523,15.22-16.041a40.4,40.4,0,0,0,2.171-20.841c-.365-2.128-2.039-2.569-3.957-1.933a5.889,5.889,0,0,0-2.126,1.349A16.915,16.915,0,0,0,193.616,214.372Z",
    transform: "translate(-153.265 -157.135)",
    fill: "#ebf3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M239.847,399.908c.315,0,.826-61.639,1.059-66.986q-6.264-.193-12.518-.625c-4.168-.287-8.094-2.109-8.807,3.065-.329,2.39.915,4.107,1.44,6.337.809,3.437.727,7.205,1.018,10.717Q224.01,376.246,226.78,400Z",
    transform: "translate(-176.351 -208.357)",
    fill: "#343a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M221.362,142.611c-.261,6.21,1.7,12.944,7.417,16.16a20.359,20.359,0,0,0,4.36,1.728,24.415,24.415,0,0,0,9.348,1.065,13.487,13.487,0,0,0,8.4-3.911,18.366,18.366,0,0,0,2.977-4.665,58,58,0,0,0,3.539-9.247c.466-1.62.728-3.68-.609-4.706a7.021,7.021,0,0,1-1.032-.734,2.512,2.512,0,0,1-.475-.968,17.186,17.186,0,0,0-1.557-4.311c-1.2-1.869-3.33-2.877-5.359-3.773-1.9-.838-3.279-1.44-5.346-1.116a28.1,28.1,0,0,0-5.312,1.378c-2.068.759-4.005,1.968-6.16,2.47-2.35.547-5.988-.1-7.521,2.106A16.489,16.489,0,0,0,221.362,142.611Z",
    transform: "translate(-177.087 -125.682)",
    fill: "#343a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M273.6,400c.314-.016-1.967-61.613-1.976-66.965q-6.267.091-12.534-.058c-4.177-.1-8.181-1.74-8.659,3.46-.22,2.4,1.1,4.062,1.725,6.266.963,3.4,1.052,7.165,1.5,10.66q3.049,23.715,6.893,47.319Z",
    transform: "translate(-188.885 -208.724)",
    fill: "#343a4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 11.631,
    height: 14.085,
    transform: "translate(55.893 34.424)",
    fill: "#f99d6e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(40.274 45.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M216.624,216.062a28.882,28.882,0,0,1,2.391-7.873c1.593-3.282,4.357-5.778,8.088-6.07,3.176-.249,6.358-.379,9.541-.491a56.167,56.167,0,0,1,8.857-.066,16.968,16.968,0,0,1,8.407,3.389c2.5,1.979,2.923,4.886,3.134,7.906,1.236,14.828,2.141,29.664,3.829,44.454.667,5.846,4.219,38.025,4.257,42.349-8.436,3.609-17.895,3.838-27.067,3.6-7.936-.209-16.012-.758-23.417-3.618-.005-13.881.753-27.725.749-41.6,0-7.174-.042-14.348.065-21.521C215.559,229.715,215.547,222.8,216.624,216.062Z",
    transform: "translate(-214.643 -201.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M241.792,238.034l-8.35-44.174h18.8Z",
    transform: "translate(-222.273 -198.337)",
    fill: "#acd4ea"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 17.339,
    cy: 13.365,
    rx: 17.339,
    ry: 13.365,
    transform: "matrix(0.056, -0.998, 0.998, 0.056, 44.798, 39.777)",
    fill: "#fac39a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M284.421,289.779c-.357-.408-2.549-3.169-3.194-2.879a.921.921,0,0,0-.356.393c-1.166,1.864-3.385,2.708-5.309,3.772a.55.55,0,0,0-.246.212.494.494,0,0,0,0,.342,4.447,4.447,0,0,0,1.164,1.78,35.1,35.1,0,0,0,4.164,3.93,1.648,1.648,0,0,0,.758.408c.752.1,1.218-.778,1.45-1.5l1.734-5.415a1.128,1.128,0,0,0,.068-.7A1.077,1.077,0,0,0,284.421,289.779Z",
    transform: "translate(-198.98 -190.145)",
    fill: "#fac39a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M250.485,151.433c1.992-6.13,1.755-11.9,1.167-18.2-.162-1.743-1.091-2.709-2.312-3.973a11.035,11.035,0,0,0-3.095-2.509c-3.451-1.617-7.616.621-11.3-.362-1.475-.395-2.769-1.283-4.2-1.806a9.136,9.136,0,0,0-9.542,2.258,4.523,4.523,0,0,0-.942,1.375,4.395,4.395,0,0,0,.313,3.46c1.345,2.847,3.631,3.44,6.257,4.514a19.173,19.173,0,0,0,6.867,1.033c2.536.033,4.921-.495,7.308.731.854.438,1.6,1.053,2.43,1.543a10.5,10.5,0,0,1,2.443,1.589,7.1,7.1,0,0,1,1.417,3.7q.643,3.455,1.592,6.844c.086.308.21.656.509.768C249.9,152.588,250.317,151.951,250.485,151.433Z",
    transform: "translate(-176.554 -124.07)",
    fill: "#343a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M281.776,235.38c-.549-5.744-4.08-9.626-6.128-14.79-1.932-4.871-3.422-10.489-2.3-15.733a1.067,1.067,0,0,1,.257-.58c.3-.279.78-.144,1.156.017a36.752,36.752,0,0,1,18.987,20.272,36.4,36.4,0,0,1,1.946,10.332A34.5,34.5,0,0,1,295,245.026c-1.416,5.872-5.118,10.483-9.938,13.931a1.191,1.191,0,0,1-1.9,0q-2.577-2.523-4.943-5.251a2.876,2.876,0,0,1-.611-.929,3.134,3.134,0,0,1,.667-2.456A25.04,25.04,0,0,0,281.776,235.38Z",
    transform: "translate(-198.037 -156.556)",
    fill: "#ebf3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M270.062,165.476a3.248,3.248,0,0,1,.616,4.932,6.138,6.138,0,0,1-4.078,2.61c-1.225.188-3,.083-3.265-1.437-.235-1.358.87-3.289,1.651-4.336C266.151,165.683,268.145,164.1,270.062,165.476Z",
    transform: "translate(-194.118 -140.662)",
    fill: "#fac39a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M240.618,200.5l3.787,5.091,8.017-5.7Z",
    transform: "translate(-184.911 -154.845)",
    fill: "#f99d6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M247.808,239.6l6.871-15.667-1.983-3.391,3.27-.022,7.378-19.021-6.421-2.227Z",
    transform: "translate(-187.829 -154.59)",
    fill: "#ebf3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M246.991,204.746l8.03-6.936,4.364,1.628-8.794,9.7Z",
    transform: "translate(-187.498 -153.997)",
    fill: "#c7e8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M237.408,241.247l-6.724-16.3,1.983-3.391-3.27-.022-6.757-17.421,7.674-2.339Z",
    transform: "translate(-177.615 -155.606)",
    fill: "#ebf3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M237.489,199.27l3.6,6.068-4.24,4.388-4.4-8.4Z",
    transform: "translate(-181.595 -154.59)",
    fill: "#c7e8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(46.379 18.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(15.992 0.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M251.835,156.759a2.044,2.044,0,0,1,1.15-.627,3.087,3.087,0,0,1,1.285.022,3.209,3.209,0,0,1,1.163.518,2.25,2.25,0,0,1,.815,1.012c-.459-.034-.828-.1-1.194-.157s-.705-.135-1.045-.214l-1.025-.249Z",
    transform: "translate(-251.835 -156.075)",
    fill: "#343a4a"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M257.785,169.971c-.039.85-1.225,1.486-2.649,1.421s-2.548-.808-2.509-1.658,1.225-1.485,2.65-1.42S257.824,169.12,257.785,169.971Z",
    transform: "translate(-236.164 -160.302)",
    fill: "#f78b7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M252.089,162.319c-.04.963.418,1.768,1.024,1.8s1.129-.724,1.169-1.686-.418-1.768-1.024-1.8S252.129,161.357,252.089,162.319Z",
    transform: "translate(-235.945 -157.187)",
    fill: "#3d2217"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(1.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M231.232,155.687l-1.171.2-1.044.154c-.346.046-.695.085-1.061.116s-.743.055-1.2.047a2.248,2.248,0,0,1,.9-.932,3.192,3.192,0,0,1,1.206-.409,3.081,3.081,0,0,1,1.281.1A2.043,2.043,0,0,1,231.232,155.687Z",
    transform: "translate(-226.753 -154.834)",
    fill: "#343a4a"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M224.92,168.3c-.039.85.906,1.583,2.11,1.639s2.213-.589,2.252-1.438-.906-1.584-2.11-1.64S224.959,167.448,224.92,168.3Z",
    transform: "translate(-224.919 -159.713)",
    fill: "#f78b7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M231.939,161.112c-.04.962-.564,1.717-1.169,1.686s-1.064-.836-1.024-1.8.563-1.717,1.169-1.686S231.979,160.15,231.939,161.112Z",
    transform: "translate(-226.877 -156.652)",
    fill: "#3d2217"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M242.817,171.8c-.026.387-.717.656-1.544.6s-1.477-.412-1.451-.8.717-.656,1.543-.6S242.842,171.413,242.817,171.8Z",
    transform: "translate(-230.967 -161.392)",
    fill: "#e59a7f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(5.404 13.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M239.433,181.514a5.15,5.15,0,0,1-5.378-4.284c-.008-.05-.015-.1-.022-.149s-.014-.1-.02-.156a13.539,13.539,0,0,0,5.191,1.031,11.769,11.769,0,0,0,5.057-.56,1.538,1.538,0,0,0-.089.345,5.2,5.2,0,0,1-1.374,2.451A5.1,5.1,0,0,1,239.433,181.514Z",
    transform: "translate(-234.014 -176.924)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 2.07,
    y2: 77.591,
    transform: "translate(59.455 70.146)",
    fill: "none",
    stroke: "#acd4ea",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M273.467,289.2l9.451,10.121-4.013,3.237L271.4,292.511Z",
    transform: "translate(-197.402 -191.086)",
    fill: "#ebf3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M220.933,292.068l-4.175,8.642,3.107,2.33,4.661-9.71Z",
    transform: "translate(-175.228 -192.251)",
    fill: "#ebf3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M254.374,278.028a.832.832,0,1,1-.831-.832A.831.831,0,0,1,254.374,278.028Z",
    transform: "translate(-189.819 -186.215)",
    fill: "#ebf3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M254.374,302.133a.832.832,0,1,1-.831-.832A.831.831,0,0,1,254.374,302.133Z",
    transform: "translate(-189.819 -195.998)",
    fill: "#ebf3f7"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(8.556 141.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 119.03,
    height: 32.211,
    fill: "#231f20",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 10.108,
    cy: 10.108,
    rx: 10.108,
    ry: 10.108,
    transform: "translate(50.539 3.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M5.942,0,7.724,3.79l4.159.522L8.826,7.176l.788,4.113L5.942,9.27,2.269,11.289l.788-4.113L0,4.312,4.159,3.79Z",
    transform: "translate(55.421 7.577)",
    fill: "#3a9cd8"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(97.891 13.672)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 70.462,
    height: 40.264,
    rx: 10,
    fill: "#2f77b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M365.449,132.333H319.926a2.206,2.206,0,0,1-2.4-1.936h0a2.206,2.206,0,0,1,2.4-1.936h45.523a2.206,2.206,0,0,1,2.4,1.936h0A2.206,2.206,0,0,1,365.449,132.333Z",
    transform: "translate(-306.863 -120.932)",
    fill: "#ebf3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M365.914,149.415H319.462a1.936,1.936,0,0,1-1.936-1.936h0a1.936,1.936,0,0,1,1.936-1.936h46.452a1.936,1.936,0,0,1,1.936,1.936h0A1.936,1.936,0,0,1,365.914,149.415Z",
    transform: "translate(-306.863 -127.865)",
    fill: "#ebf3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M351.048,166.5H319.926a2.206,2.206,0,0,1-2.4-1.936h0a2.206,2.206,0,0,1,2.4-1.936h31.121a2.206,2.206,0,0,1,2.4,1.936h0A2.206,2.206,0,0,1,351.048,166.5Z",
    transform: "translate(-306.863 -134.798)",
    fill: "#ebf3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M310.874,180.732v11.911l16.609-10.9Z",
    transform: "translate(-304.163 -142.146)",
    fill: "#2f77b6"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 7.231,
    cy: 7.231,
    rx: 7.231,
    ry: 7.231,
    transform: "translate(61.993 175.05)",
    fill: "#343a4a",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037",
    transform: "translate(0 0)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    transform: "translate(16.653 80.848)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 29.879,
    height: 17.073,
    rx: 8.537,
    transform: "translate(29.879 17.073) rotate(180)",
    fill: "#92d4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M136.208,97.7v5.051l-7.043-4.624Z",
    transform: "translate(-109.175 -81.334)",
    fill: "#92d4d6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 1.838,
    cy: 1.838,
    rx: 1.838,
    ry: 1.838,
    transform: "translate(5.587 6.257)",
    fill: "#ebf3f7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 1.838,
    cy: 1.838,
    rx: 1.838,
    ry: 1.838,
    transform: "translate(12.6 6.257)",
    fill: "#ebf3f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M131.809,71.868a1.838,1.838,0,1,1-1.838-1.838A1.838,1.838,0,0,1,131.809,71.868Z",
    transform: "translate(-108.52 -63.773)",
    fill: "#ebf3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028",
    transform: "translate(161.868 138)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 13.532,
    cy: 13.532,
    rx: 13.532,
    ry: 13.532,
    fill: "#92d4d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027",
    transform: "translate(7.082 7.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(5.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 1.782,
    height: 12.9,
    fill: "#ebf3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026",
    transform: "translate(0 5.559)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 12.9,
    height: 1.782,
    fill: "#ebf3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032",
    transform: "translate(8.436 115.617)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 8.216,
    cy: 8.216,
    rx: 8.216,
    ry: 8.216,
    fill: "#92d4d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031",
    transform: "translate(4.3 4.3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029",
    transform: "translate(3.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 1.082,
    height: 7.832,
    fill: "#ebf3f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030",
    transform: "translate(0 3.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 7.832,
    height: 1.082,
    fill: "#ebf3f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034",
    transform: "translate(188.933 107.4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 8.216,
    cy: 8.216,
    rx: 8.216,
    ry: 8.216,
    fill: "#92d4d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033",
    transform: "translate(5.825 4.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M403.624,225.157v-.384a1.7,1.7,0,0,1,.213-.866,2.78,2.78,0,0,1,.778-.783,3.272,3.272,0,0,0,.718-.633.917.917,0,0,0,.174-.545.59.59,0,0,0-.249-.513,1.189,1.189,0,0,0-.7-.176,4,4,0,0,0-1.774.508l-.565-1.136a4.943,4.943,0,0,1,2.453-.648,2.61,2.61,0,0,1,1.7.513,1.678,1.678,0,0,1,.63,1.37,1.823,1.823,0,0,1-.26.986,3.7,3.7,0,0,1-.985.933,3.053,3.053,0,0,0-.63.56.869.869,0,0,0-.132.5v.311Zm-.166,1.774a.869.869,0,0,1,.233-.659.948.948,0,0,1,.68-.223.921.921,0,0,1,.667.229,1.008,1.008,0,0,1,0,1.3.9.9,0,0,1-.664.236.931.931,0,0,1-.674-.231A.862.862,0,0,1,403.458,226.931Z",
    transform: "translate(-402.224 -219.98)",
    fill: "#ebf3f7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group1.ad8bf14408610defe5d00be18dafc9f9.svg";
export { ForwardRef as ReactComponent };